import { DesignerObjectType } from '../graphql-api-enums.generated.ts';

export const isDesignerObjectType = (value: unknown): value is DesignerObjectType =>
  typeof value === 'string' && value in DesignerObjectType;

export const designerObjectTypeOrNull = (value: unknown): DesignerObjectType | null =>
  isDesignerObjectType(value) ? value : null;
